module.exports = __webpack_public_path__ + "img/box8.f3707897.png";